import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "./PostDetailMobile.css";
import { withNavigation } from "../../utils/withNavigation";

class PostDetailMobile extends Component {
  constructor(props) {
    super(props);
    const today = new Date();

    this.state = {
      hotel: null,
      loading: true,
      error: null,
      bookedDates: [],

      checkIn: null,
      checkOut: null,
      rooms: 1,
      adults: 1,
      children: 0,
      remarks: "",
      cleaningFee: 0,
      discount: 0,

      calendarBase: new Date(today.getFullYear(), today.getMonth(), 1),
      showCalendar: false,

      isGalleryOpen: false,
      currentImageIndex: 0,
      showFullDescription: false,
      bookingLoading: false
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    const id = this.props.params?.id;

    if (id) {
      this.loadPost(id);
      this.fetchBookedDates(id);
      this.updateRecentlyViewed(id);
    } else {
      this.setState({
        loading: false,
        error: "Property ID is missing."
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.body.style.overflow = "";
  }

  loadPost = async (postId) => {
    this.setState({ loading: true, error: null });

    try {
      const res = await axios.get(`/get_post_by_id?id=${postId}`);
      const data = Array.isArray(res.data?.data) ? res.data.data[0] : res.data.data;

      if (!data) {
        this.setState({ loading: false, error: "Property not found." });
        return;
      }

      let gallery = [];
      try {
        gallery = data.gallery_images ? JSON.parse(data.gallery_images) : [];
      } catch (error) {
        gallery = [];
      }

      data.all_images = data.feature_image ? [data.feature_image, ...gallery] : gallery;
      const defaultAdults = data.adults ? Math.min(2, Number(data.adults)) : 1;

      this.setState({
        hotel: data,
        adults: defaultAdults,
        loading: false
      });
    } catch (error) {
      console.error("Property fetch error:", error);
      this.setState({ loading: false, error: "Failed to load property details." });
    }
  };

  fetchBookedDates = async (postId) => {
    try {
      const res = await axios.get(`/booked_dates?post_id=${postId}`);
      this.setState({ bookedDates: res.data?.data || [] });
    } catch (error) {
      console.error("Booked dates fetch error:", error);
    }
  };

  updateRecentlyViewed = (id) => {
    try {
      let viewed = JSON.parse(localStorage.getItem("recently_viewed_products")) || [];
      viewed = viewed.filter((item) => parseInt(item) !== parseInt(id));
      viewed.unshift(id);
      viewed = viewed.slice(0, 20);
      localStorage.setItem("recently_viewed_products", JSON.stringify(viewed));
    } catch (error) {
      console.error("Recently viewed error:", error);
    }
  };

  getImageUrl = (image) => {
    const baseUrl = axios.defaults.baseURL ? axios.defaults.baseURL.replace("/api", "") : "";
    return `${baseUrl}/uploads/posts/${image}`;
  };

  openGallery = (index = 0) => {
    this.setState({ isGalleryOpen: true, currentImageIndex: index });
    document.body.style.overflow = "hidden";
  };

  closeGallery = () => {
    this.setState({ isGalleryOpen: false });
    document.body.style.overflow = "";
  };

  nextImage = () => {
    this.setState((prevState) => {
      const images = prevState.hotel?.all_images || [];
      if (!images.length) return null;
      return { currentImageIndex: (prevState.currentImageIndex + 1) % images.length };
    });
  };

  prevImage = () => {
    this.setState((prevState) => {
      const images = prevState.hotel?.all_images || [];
      if (!images.length) return null;
      return {
        currentImageIndex: prevState.currentImageIndex === 0 ? images.length - 1 : prevState.currentImageIndex - 1
      };
    });
  };

  handleKeyDown = (event) => {
    if (!this.state.isGalleryOpen) return;
    if (event.key === "ArrowRight") this.nextImage();
    if (event.key === "ArrowLeft") this.prevImage();
    if (event.key === "Escape") this.closeGallery();
  };

  handleImageError = (event) => {
    event.target.onerror = null;
    event.target.style.display = "none";
    if (event.target.parentElement) {
      event.target.parentElement.classList.add("mobile-image-fallback");
    }
  };

  toggleDescription = () => {
    this.setState((prevState) => ({ showFullDescription: !prevState.showFullDescription }));
  };

  getPlainDescription = () => {
    const { hotel } = this.state;
    if (!hotel?.content) return "";
    const temporaryElement = document.createElement("div");
    temporaryElement.innerHTML = hotel.content;
    return (temporaryElement.textContent || temporaryElement.innerText || "").trim();
  };

  handleGuestChange = (type, operation) => {
    this.setState((prevState) => {
      const hotel = prevState.hotel;
      if (!hotel) return null;

      let currentValue = Number(prevState[type]) || 0;
      let maximum = 10;

      if (type === "rooms") maximum = Number(hotel.room_number) || 10;
      if (type === "adults") maximum = Number(hotel.adults) || 10;
      if (type === "children") maximum = Number(hotel.children) || 10;

      if (operation === "add") currentValue = Math.min(currentValue + 1, maximum);
      if (operation === "sub") {
        const minimum = type === "children" ? 0 : 1;
        currentValue = Math.max(currentValue - 1, minimum);
      }
      return { [type]: currentValue };
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  getLocalDateString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  formatDateString = (date) => {
    if (!date) return "Select date";
    return new Date(date).toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" });
  };

  getNights = () => {
    const { checkIn, checkOut } = this.state;
    if (!checkIn || !checkOut) return 0;
    return Math.ceil(Math.abs(new Date(checkOut) - new Date(checkIn)) / (1000 * 60 * 60 * 24));
  };

  // HELPER: Checks if a specific date is blocked for Check-In (allows back-to-back bookings)
  isDateBlockedForCheckIn = (date) => {
    const dateStr = this.getLocalDateString(date);
    const { bookedDates } = this.state;
    for (let i = 0; i < bookedDates.length; i++) {
      const b = bookedDates[i];
      if (dateStr >= b.checkin_date && dateStr < b.checkout_date) return true;
    }
    return false;
  };

  // HELPER: Checks overlapping date ranges accurately against booked date objects
  isDateRangeFree = (start, end) => {
    const { bookedDates } = this.state;
    const startStr = this.getLocalDateString(start);
    const endStr = this.getLocalDateString(end);

    for (let i = 0; i < bookedDates.length; i++) {
      const b = bookedDates[i];
      if (startStr < b.checkout_date && endStr > b.checkin_date) {
        return false;
      }
    }
    return true;
  };

  changeMonth = (offset) => {
    this.setState((prevState) => ({
      calendarBase: new Date(prevState.calendarBase.getFullYear(), prevState.calendarBase.getMonth() + offset, 1)
    }));
  };

  handleDayClick = (clickedDate) => {
    const { checkIn, checkOut } = this.state;
    const todayString = this.getLocalDateString(new Date());

    if (this.getLocalDateString(clickedDate) < todayString) return;

    if (!checkIn || (checkIn && checkOut)) {
      if (this.isDateBlockedForCheckIn(clickedDate)) return;
      this.setState({ checkIn: clickedDate, checkOut: null });
    } else {
      if (clickedDate <= checkIn) {
        if (!this.isDateBlockedForCheckIn(clickedDate)) {
          this.setState({ checkIn: clickedDate });
        }
      } else {
        if (this.isDateRangeFree(checkIn, clickedDate)) {
          this.setState({ checkOut: clickedDate, showCalendar: false });
        } else {
          alert("This date range contains already booked dates.");
          if (!this.isDateBlockedForCheckIn(clickedDate)) {
            this.setState({ checkIn: clickedDate });
          }
        }
      }
    }
  };

  renderCalendar = () => {
    const { calendarBase, checkIn, checkOut } = this.state;
    const year = calendarBase.getFullYear();
    const month = calendarBase.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const todayString = this.getLocalDateString(new Date());
    const monthName = calendarBase.toLocaleString("en-US", { month: "long", year: "numeric" });
    const days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="mobile-calendar-day empty" />);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const currentDate = new Date(year, month, day);
      const currentString = this.getLocalDateString(currentDate);
      const isPast = currentString < todayString;
      let isBooked = false;

      if (isPast) {
        isBooked = true;
      } else if (!checkIn || (checkIn && checkOut)) {
        isBooked = this.isDateBlockedForCheckIn(currentDate);
      } else {
        if (currentDate <= checkIn) {
          isBooked = this.isDateBlockedForCheckIn(currentDate);
        } else {
          isBooked = !this.isDateRangeFree(checkIn, currentDate);
        }
      }

      const isCheckIn = checkIn && this.getLocalDateString(checkIn) === currentString;
      const isCheckOut = checkOut && this.getLocalDateString(checkOut) === currentString;
      const isInRange = checkIn && checkOut && currentDate > checkIn && currentDate < checkOut;

      let className = "mobile-calendar-day";
      if (isPast || isBooked) className += " disabled";
      if (isCheckIn) className += " selected-start";
      if (isCheckOut) className += " selected-end";
      if (isInRange) className += " in-range";

      days.push(
        <button
          key={day}
          type="button"
          disabled={isPast || isBooked}
          className={className}
          onClick={() => this.handleDayClick(currentDate)}
        >
          {day}
        </button>
      );
    }

    return (
      <div className="mobile-calendar">
        <div className="calendar-header">
          <button type="button" className="calendar-nav-button" onClick={() => this.changeMonth(-1)}>‹</button>
          <strong>{monthName}</strong>
          <button type="button" className="calendar-nav-button" onClick={() => this.changeMonth(1)}>›</button>
        </div>
        <div className="calendar-weekdays">
          <span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span>
        </div>
        <div className="calendar-grid">{days}</div>
        <div className="calendar-help">Select check-in first, then check-out.</div>
      </div>
    );
  };

  calculateTotals = () => {
    const { hotel, cleaningFee, discount, rooms } = this.state;
    if (!hotel) return { totalNights: 0, roomPrice: 0, tax: 0, grandTotal: 0, pricePerNight: 0 };

    const pricePerNight = Number(hotel.sales_price) || 0;
    const totalNights = this.getNights();
    const roomPrice = pricePerNight * totalNights * rooms;
    const tax = roomPrice * 0.1;
    const grandTotal = roomPrice + Number(cleaningFee || 0) + tax - Number(discount || 0);

    return { totalNights, roomPrice, tax, grandTotal, pricePerNight };
  };

  handleBooking = async () => {
    const { hotel, checkIn, checkOut, rooms, adults, children, remarks } = this.state;
    const { grandTotal } = this.calculateTotals();
    const webUserId = localStorage.getItem("web_user_id");

    if (!webUserId) {
      alert("Please login first.");
      return;
    }
    if (!checkIn || !checkOut) {
      alert("Please select check-in and check-out dates.");
      return;
    }
    if (new Date(checkIn) >= new Date(checkOut)) {
      alert("Check-out date must be after check-in date.");
      return;
    }
    if (!this.isDateRangeFree(checkIn, checkOut)) {
      alert("Your selected dates contain already booked dates.");
      return;
    }

    this.setState({ bookingLoading: true });
    try {
      await axios.post("book_room", {
        post_id: Number(hotel.id),
        customer_id: Number(webUserId),
        host_id: Number(hotel.customer_id),
        checkin_date: this.getLocalDateString(checkIn),
        checkout_date: this.getLocalDateString(checkOut),
        rooms: Number(rooms),
        adults: Number(adults),
        children: Number(children),
        remarks,
        totalAmount: Number(grandTotal)
      });
      alert("Booking successful!");
      window.location.href = "/chat";
    } catch (error) {
      console.error("Booking failed:", error);
      alert("Booking failed. Please try again.");
    } finally {
      this.setState({ bookingLoading: false });
    }
  };

  renderGuestCounter = (label, type, value) => {
    return (
      <div className="guest-row">
        <div className="guest-label">
          <strong>{label}</strong>
          <span>{type === "rooms" ? "Rooms" : type === "adults" ? "Age 13+" : "Age 2–12"}</span>
        </div>
        <div className="guest-counter">
          <button type="button" onClick={() => this.handleGuestChange(type, "sub")}>−</button>
          <strong>{value}</strong>
          <button type="button" onClick={() => this.handleGuestChange(type, "add")}>+</button>
        </div>
      </div>
    );
  };

  render() {
    const {
      hotel, loading, error, checkIn, checkOut, rooms, adults, children,
      remarks, showCalendar, isGalleryOpen, currentImageIndex,
      showFullDescription, bookingLoading
    } = this.state;

    if (loading) {
      return (
        <div className="mobile-detail-loading">
          <div className="mobile-loading-spinner" />
          <h3>Loading property...</h3>
          <p>Please wait a moment.</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="mobile-detail-error">
          <div className="error-icon">!</div>
          <h3>Unable to load property</h3>
          <p>{error}</p>
          <button type="button" onClick={() => window.location.reload()}>Try Again</button>
        </div>
      );
    }

    if (!hotel) return null;

    const baseUrl = axios.defaults.baseURL ? axios.defaults.baseURL.replace("/api", "") : "";
    const uploadUrl = `${baseUrl}/uploads/posts/`;
    const images = hotel.all_images?.map((image) => `${uploadUrl}${image}`) || [];
    const { totalNights, roomPrice, tax, grandTotal, pricePerNight } = this.calculateTotals();

    const description = this.getPlainDescription();
    const descriptionLimit = 280;
    const hasLongDescription = description.length > descriptionLimit;
    const displayedDescription = showFullDescription || !hasLongDescription ? description : `${description.substring(0, descriptionLimit)}...`;

    return (
      <div className="mobile-property-page">

        {/* FULLSCREEN PHOTO GALLERY */}
        {isGalleryOpen && (
          <div className="mobile-fullscreen-gallery">
            <button type="button" className="gallery-close-button" onClick={this.closeGallery}>×</button>
            <div className="gallery-counter">{currentImageIndex + 1} / {images.length}</div>
            <button type="button" className="gallery-arrow gallery-arrow-left" onClick={this.prevImage}>‹</button>
            <img src={images[currentImageIndex]} alt="Property" className="fullscreen-gallery-image" />
            <button type="button" className="gallery-arrow gallery-arrow-right" onClick={this.nextImage}>›</button>
            <div className="fullscreen-thumbnails">
              {images.map((image, index) => (
                <button
                  type="button"
                  key={index}
                  className={currentImageIndex === index ? "gallery-thumbnail active" : "gallery-thumbnail"}
                  onClick={() => this.setState({ currentImageIndex: index })}
                >
                  <img src={image} alt="" />
                </button>
              ))}
            </div>
          </div>
        )}

        {/* HEADER */}
        <header className="mobile-detail-header">
          <button type="button" className="mobile-back-button" onClick={() => window.history.back()}>
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M20 12H4M4 12L10 6M4 12L10 18" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <div className="mobile-header-title">Details</div>
        </header>

        {/* PHOTO GRID */}
        <section className="mobile-photo-section-new">
          <div className="main-photo-wrapper" onClick={() => this.openGallery(0)}>
            {images.length > 0 ? (
              <img src={images[0]} alt={hotel.title || "Property"} onError={this.handleImageError} />
            ) : (
              <div className="mobile-no-image">🏠</div>
            )}
            
            <button 
              className="floating-share-btn" 
              onClick={(e) => {
                e.stopPropagation();
                if (navigator.share) {
                  navigator.share({ title: hotel.title, url: window.location.href });
                } else {
                  navigator.clipboard.writeText(window.location.href);
                  alert("Property link copied.");
                }
              }}
            >
              Share 
              <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                 <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            {images.length > 0 && (
              <div className="photo-dots-indicator">
                {images.slice(0, 5).map((_, i) => (
                  <span key={i} className={`photo-dot ${i === 0 ? 'active' : ''}`} />
                ))}
              </div>
            )}
          </div>

          {images.length > 1 && (
            <div className="thumbnails-row">
              <div className="thumb-wrapper" onClick={() => this.openGallery(1)}>
                <img src={images[1]} alt="Thumbnail 1" />
              </div>
              
              {images.length > 2 && (
                <div className="thumb-wrapper" onClick={() => this.openGallery(2)}>
                  <img src={images[2]} alt="Thumbnail 2" />
                  <button className="floating-show-more-btn" onClick={(e) => { e.stopPropagation(); this.openGallery(0); }}>
                    Show More
                  </button>
                </div>
              )}
            </div>
          )}
        </section>

        {/* MAIN DETAILS */}
        <main className="mobile-detail-content">
          
          <h1 className="mobile-property-title-new">{hotel.title}</h1>

          {/* AMENITIES */}
          <div className="mobile-stats-row">
            <div className="stat-item">
              <span className="stat-label">Max Guest</span>
              <div className="stat-value">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {Number(hotel.adults || 0) + Number(hotel.children || 0)}
              </div>
            </div>
            
            <div className="stat-divider" />
            
            <div className="stat-item">
              <span className="stat-label">Bedroom</span>
              <div className="stat-value">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {hotel.room_number || 1}
              </div>
            </div>
            
            <div className="stat-divider" />
            
            <div className="stat-item">
              <span className="stat-label">Bed</span>
              <div className="stat-value">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M3 7v10M21 7v10M3 14h18M6 10h.01M18 10h.01" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {hotel.beds || 1}
              </div>
            </div>

            <div className="stat-divider" />

            <div className="stat-item">
              <span className="stat-label">Bath</span>
              <div className="stat-value">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M4 12v6a2 2 0 002 2h12a2 2 0 002-2v-6M4 12a4 4 0 014-4h8a4 4 0 014 4M9 5V3m6 2V3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {hotel.baths || 1}
              </div>
            </div>
          </div>

          {/* CHECK IN/OUT */}
          <div className="mobile-check-times">
            <div className="time-item">
              <span className="time-label">Check In</span>
              <div className="time-value">
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M12 22a10 10 0 100-20 10 10 0 000 20zM12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {hotel.checkin_time || "01:00 PM"}
              </div>
            </div>
            <div className="time-item">
              <span className="time-label">Check Out</span>
              <div className="time-value">
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M12 22a10 10 0 100-20 10 10 0 000 20zM12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {hotel.checkout_time || "10:00 AM"}
              </div>
            </div>
          </div>

          {/* TAGS */}
          {hotel.tag_ids && (
            <section className="mobile-section">
              <h2 className="mobile-section-title">Property Tags</h2>
              <div className="mobile-tags">
                {String(hotel.tag_ids).split(",").map((tag, index) => (
                  <span key={index} className="mobile-tag">#{tag.trim()}</span>
                ))}
              </div>
            </section>
          )}

          {/* DESCRIPTION */}
          <section className="mobile-section">
            <h2 className="mobile-section-title">About This Property</h2>
            <div className="mobile-description">
              {displayedDescription || "No description available."}
            </div>
            {hasLongDescription && (
              <button type="button" className="mobile-more-button" onClick={this.toggleDescription}>
                {showFullDescription ? "Show Less" : "More Details"}
                <span>{showFullDescription ? "↑" : "↓"}</span>
              </button>
            )}
          </section>

          {/* LOCATION MAP */}
          <section className="mobile-section">
            <h2 className="mobile-section-title">Location</h2>
            <div className="mobile-map-card">
              <iframe
                title="Property Location"
                src={`https://www.google.com/maps?q=${hotel.map_latitude},${hotel.map_longitude}&z=15&output=embed`}
                width="100%"
                height="230"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
              <div className="mobile-map-footer">
                <div>
                  <strong>Property Location</strong>
                  <span>{hotel.map_latitude}, {hotel.map_longitude}</span>
                </div>
                <a
                  href={`https://www.google.com/maps?q=${hotel.map_latitude},${hotel.map_longitude}`}
                  target="_blank"
                  rel="noreferrer"
                  className="mobile-map-button"
                >
                  Open Map
                </a>
              </div>
            </div>
          </section>

          {/* BOOKING SECTION */}
          <section className="mobile-booking-section">
            <div className="booking-price-header">
              <div>
                <span className="booking-price">৳{Number(pricePerNight).toLocaleString("en-BD")}</span>
                <span className="booking-per-night">/ night</span>
              </div>
              <span className="instant-book-badge">Instant Book</span>
            </div>

            <div className="mobile-date-picker">
              <div className="date-picker-label">Check-in / Check-out</div>
              <div className="date-picker-values">
                <button type="button" className={checkIn ? "date-box selected" : "date-box"} onClick={() => this.setState({ showCalendar: true })}>
                  <small>CHECK-IN</small>
                  <strong>{this.formatDateString(checkIn)}</strong>
                </button>
                <div className="date-arrow">→</div>
                <button type="button" className={checkOut ? "date-box selected" : "date-box"} onClick={() => this.setState({ showCalendar: true })}>
                  <small>CHECK-OUT</small>
                  <strong>{this.formatDateString(checkOut)}</strong>
                </button>
              </div>

              {showCalendar && (
                <div className="mobile-calendar-container">
                  {this.renderCalendar()}
                  <button type="button" className="calendar-close" onClick={() => this.setState({ showCalendar: false })}>Done</button>
                  <button type="button" className="calendar-clear" onClick={() => this.setState({ checkIn: null, checkOut: null })}>Clear dates</button>
                </div>
              )}
            </div>

            <div className="mobile-guests-box">
              <div className="guest-section-title">Guests & Rooms</div>
              {this.renderGuestCounter("Rooms", "rooms", rooms)}
              {this.renderGuestCounter("Adults", "adults", adults)}
              {this.renderGuestCounter("Children", "children", children)}
            </div>

            <div className="mobile-remarks">
              <label>Remarks</label>
              <textarea name="remarks" value={remarks} onChange={this.handleInputChange} placeholder="Anything you want to tell the host..." rows="4" />
            </div>

            {checkIn && checkOut ? (
              <div className="mobile-price-summary">
                <div className="summary-row">
                  <span>৳{pricePerNight.toLocaleString("en-BD")} × {totalNights} nights × {rooms} room{rooms > 1 ? "s" : ""}</span>
                  <strong>৳{roomPrice.toLocaleString("en-BD")}</strong>
                </div>
                <div className="summary-row">
                  <span>Cleaning fee</span>
                  <strong>৳{Number(this.state.cleaningFee).toLocaleString("en-BD")}</strong>
                </div>
                <div className="summary-row">
                  <span>Taxes (10%)</span>
                  <strong>৳{tax.toFixed(2)}</strong>
                </div>
                {this.state.discount > 0 && (
                  <div className="summary-row discount">
                    <span>Special Discount</span>
                    <strong>-৳{Number(this.state.discount).toLocaleString("en-BD")}</strong>
                  </div>
                )}
                <div className="summary-divider" />
                <div className="summary-total">
                  <span>Total</span>
                  <strong>৳{grandTotal.toFixed(2)}</strong>
                </div>
              </div>
            ) : (
              <div className="mobile-date-warning">Select your check-in and check-out dates to see the total price.</div>
            )}

            <button type="button" className="mobile-reserve-button" disabled={!checkIn || !checkOut || bookingLoading} onClick={this.handleBooking}>
              {bookingLoading ? (
                <><span className="button-spinner" />Processing...</>
              ) : (
                <>Reserve Now<span>→</span></>
              )}
            </button>
            <p className="booking-note">You won't be charged yet.</p>
          </section>

        </main>
      </div>
    );
  }
}

export default withNavigation(PostDetailMobile);
